import { FORMAT_DATE } from './Constant';

export const INVALID_TENANT_CODE = 'Invalid tenant code';
export const REPORT_NOT_FOUND = 'Report not found';

export const INVALID_DATE = 'Invalid Date';
export const INVALID_DATE_FORMAT = `Invalid format, should be ${FORMAT_DATE}`;
export const INVALID_DATE_RANGE = 'The year should be between 1900 & 2099';
export const END_DATE_LATER_THAN_START_DATE = 'End Date must be later than Start Date';

export const INVALID_ANNUAL_PLAN_RENEWAL_CASE_STATUS = 'This case is in an invalid renewal case status';
